import { LitElement, html } from 'lit-element';
import { formatNumber, formatDateTime } from '../../utils/intl';

import { priceTypes, thresholdDirections as directions } from './alert-types';
import translate from '../../utils/webcomponents/translate';

import alertEvents from './alert-events';

import Tooltip from '../tooltip';

const renderActionButton = (label, icon, clickCallback) => html`
	<div class="manageable-list__item-button">
		<button class="button button--ghost button--icon-only button--small" @click="${clickCallback}" data-option-tooltip-text="${label}">
			<span class="button__icon">
				<x-icon icon="${icon}"></x-icon>
			</span>
		</button>
	</div>`;

const getPriceTypeTranslation = (value, fallback = '-') => {
	const resourceKey = value === 1
		? priceTypes.bid.resourceKey
		: priceTypes.ask.resourceKey;

	return translate('alerts', resourceKey, fallback);
};

const getDirectionTranslation = (value, fallback = '-') => {
	const resourceKey = value === 1
		? directions.down.resourceKey
		: directions.up.resourceKey;

	return translate('alerts', resourceKey, fallback);
};

const getFormattedTriggered = (value, resourceKey, fallback = 'no') => {
	if (value) {
		const date = new Date(value);

		return formatDateTime(date);
	}

	return translate('alerts', resourceKey, fallback);
};

const isInActive = ({ triggered, isTradeable }) => triggered || !isTradeable;

class AlertItem extends LitElement {
	static get properties() {
		return {
			item: { type: Object },
		};
	}

	firstUpdated() {
		this.createTooltips();

		this.classList.toggle('is-inactive', isInActive(this.item));
	}

	render() {
		const {
			productName: name,
			isin,
			thresholdDirection,
			priceType,
			threshold,
			triggered,
			isTradeable,
			productUrl: url,
		} = this.item;

		const canEdit = isTradeable;
		const editIcon = triggered ? 'reactivate' : 'edit';

		const editCallback = triggered ? this.addAlert : this.editAlert;
		const labelDelete = translate('alerts', 'delete', 'Delete');
		const labelEdit = translate('alerts', 'edit', 'Edit');

		return html`
			<div class="table__cell manageable-list__item-action">
				${canEdit ? renderActionButton(labelEdit, editIcon, editCallback) : ''}
				${renderActionButton(labelDelete, 'delete', this.removeAlert)}
			</div>
			<div class="table__cell">
				<a class="manageable-list__item-link" href="${url}">${name}</a>
				<br />
				<a class="manageable-list__item-link manageable-list__item-link--small" href="${url}">${isin}</a>
			</div>
			<div class="table__cell">${getPriceTypeTranslation(priceType)}</div>
			<div class="table__cell">${getDirectionTranslation(thresholdDirection)}</div>
			<div class="table__cell text-right">${formatNumber(threshold)}</div>
			<div class="table__cell">${getFormattedTriggered(triggered, 'notTriggered')}</div>
		`;
	}

	createTooltips() {
		const tooltips = Array.from(this.querySelectorAll('[data-option-tooltip-text]'));

		tooltips.forEach(tooltip => new Tooltip(tooltip).start());
	}

	addAlert() {
		const alert = { ...this.item, alertConditionId: null };

		this.dispatchCustomEvent(alertEvents.EDIT, alert);
	}

	editAlert() {
		this.dispatchCustomEvent(alertEvents.EDIT, this.item);
	}

	removeAlert() {
		this.dispatchCustomEvent(alertEvents.REMOVE, this.item);
	}

	dispatchCustomEvent(eventName, detail) {
		const event = new CustomEvent(eventName, {
			bubbles: true,
			detail,
		});

		this.dispatchEvent(event);
	}


	createRenderRoot() {
		return this;
	}
}

customElements.define('x-alert-item', AlertItem);

export default AlertItem;
